import { fr } from "../locales/fr";
import { en } from "../locales/en";
import type { Messages } from "../locales/fr";
import type { Language } from "../game/types";

const dictionaries: Record<Language, Messages> = { fr, en };

export class LocalizationSystem {
  language: Language = "fr";

  setLanguage(language: Language): void {
    this.language = language;
    document.documentElement.lang = language;
  }

  get t(): Messages {
    return dictionaries[this.language];
  }
}
